import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { setPromoCode, hasPromoCode } from '../api/client'

/**
 * Hook that checks for a promo_code URL parameter and auto-applies it.
 * After applying, the parameter is removed from the URL.
 *
 * Usage: Add ?promo_code=XXXXX to any URL to auto-apply the promo code.
 */
export function usePromoCodeFromUrl(): void {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const promoCode = searchParams.get('promo_code')

    if (promoCode && !hasPromoCode()) {
      // Apply the promo code
      setPromoCode(promoCode)

      // Remove the promo_code param from URL (keeps other params)
      const newParams = new URLSearchParams(searchParams)
      newParams.delete('promo_code')
      setSearchParams(newParams, { replace: true })
    }
  }, [searchParams, setSearchParams])
}
